// extracted by mini-css-extract-plugin
module.exports = {"waitrose":"more-from-us-logo_waitrose__SGaaN"};